<template>
	<div class="detail wp-width">
		<div class="detail-container">
			<div class="detail-left">
				<div class="detail-date">{{plan.title}} {{ $t('Pass') }}</div>
				<span class="kind">({{ plan.kids + (plan.kids>1?' kids':' kid') }})</span>
				<div class="price">
					<span
						>{{ plan.price }}<span>{{ '/Month' }}</span></span
					>
				</div>
			</div>
			<div class="detail-right">
				<span class="detail-title">{{ 'Next billing date: ' }}</span>
				<span class="detail-date">{{ plan.renew_at }}</span>
				<div class="detail-link">
					<router-link to="history/charges">{{ $t('view charges') }}</router-link>
					<router-link to="history/billing">{{ $t('view billing history') }}</router-link>
				</div>
				<div  class="divtwo" style="margin-top:20px;margin-bottom:20px;">
					<span class="detail-title"> {{$t('Pass expire date :')}} </span>
					<span class="detail-date">{{ plan.member_expire_at}}</span>
				</div>
				<span class="detail-pay">{{ $t('Payment method') }}:</span>
				<div class="detail-pay-content">
					<img src="../assets/img/502.png" alt="" />
					<div>
						<span class="detail-list-1">{{ plan.member_pay_method }}</span>
						<!-- <span class="detail-list-2">{{ $t('Expires') + ':' + plan.member_expire_at }}</span>
						<span class="detail-list-3">{{ $t('Update') }}</span> -->
					</div>
				</div>
			</div>
		</div>
		<div class="plan-message">
			<span style="font-weight: 600">{{ $t('Changing plan') }}&nbsp;</span>
			<span>{{ $t('Pls contact our advisor for assistance') }}</span>
		</div>
		<wp-mandy v-if="device === 'pc'"></wp-mandy>
		<div class="mandy" v-else>
			<wp-mandy-mini :radius="true"></wp-mandy-mini>
		</div>
		<div class="round"></div>
	</div>
</template>

<script>
	import WpMandy from '../components/WpMandy.vue';

	import { getMyPlanList } from '../api';
	import WpMandyMini from '../components/WpMandyMini.vue';
import { getStore } from '../store';
	export default {
		components: { WpMandy, WpMandyMini },
		data() {
			return {
				plan: {},
			};
		},
		computed: {
			device() {
				return window.innerWidth > 768 ? 'pc' : 'mobile';
			},
		},
		async mounted() {
			 this.plan= await getMyPlanList();
			// var m =await this.openCenter()
			// await this.gitdataint();
			
		},
		methods:{
			openCenter() {
				 const loading = this.$loading({
					lock: true,
					text: getStore('lang')=='en'?'Status acquisition in progress...':'支付状态获取中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
					});
					setTimeout(() => {
						if(this.plan!=''){
						loading.close();
						}
					}, 4000);
				
			},
			gitdataint(){
				var enternt = setTimeout(async() => {
					 this.plan= await getMyPlanList();
						if(this.plan){
						 clearTimeout(enternt)
						}
					}, 3000);
			}
		}
	};
</script>

<style lang="less" scoped>
	@media screen and (min-width: @device) {
		.detail-left,
		.detail-right {
			padding-left: 91px;
		}

		.detail-date {
			// width: 227px;
			// height: 93px;
		}

		.kind {
			margin-top: 52px;
		}

		.plan-message {
			margin-top: 106px;
		}

		.round {
			position: absolute;
			width: 585px;
			height: 585px;
			left: -84px;
			top: -140px;

			background: #f2f9ff;
			border: 46.6311px solid #f2f9ff;
			box-sizing: border-box;
			border-radius: 666.159px;
			z-index: -1;
		}
	}

	@media screen and (max-width: @device) {
		.detail-left,
		.detail-right {
			align-items: center;
		}

		.kind {
			margin-top: 8px;
		}

		.detail-right {
			margin-top: 30px;
		}

		.detail-pay-content {
			border: 1px solid #e8e8e8;
			border-radius: 10px;
			padding: 20px;
			box-sizing: border-box;
			width: 90%;
		}
		.plan-message {
			margin-top: 20px;
		}
		.detail-right {
			.divtwo{
				text-align: center;
			}
		}
	}

	.detail-container {
		margin-top: 75px;
		// height: 291px;
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;

		> div {
			flex-grow: 2;
		}
	}

	.detail-left {
		// padding-left: 91px;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;

		.kind {
			font-weight: 500;
			font-size: 17px;
			line-height: 17px;
			// margin-top: 25px;
		}

		.price {
			color: #4b69fe;
			margin-top: 30px;

			span {
				font-weight: 600;
				font-size: 40px;
				line-height: 40px;

				> span {
					font-weight: 500;
					font-size: 15px;
				}
			}
		}

		.detail-date {
			font-weight: bold;
			font-size: 45px;
			line-height: 52px;
			// width: 227px;
			// height: 93px;
		}
	}

	.detail-right {
		border-left: 1px solid #e6e6e6;
		// padding-left: 91px;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;

		.detail-title {
			font-weight: 600;
			font-size: 18px;
			line-height: 18px;
		}
		.divtwo{
			display: -webkit-flex;
			display: flex;
			-webkit-flex-direction: column;
			flex-direction: column;
		}
		.detail-date {
			font-weight: 600;
			font-size: 22px;
			line-height: 20px;
			color: #4b69fe;
			margin-top: 25px;
		}

		.detail-link {
			font-weight: 600;
			font-size: 13px;
			line-height: 14px;
			margin-top: 16px;
			color: #4b69fe;

			> *:first-child {
				margin-right: 5px;
			}

			> *:last-child {
				margin-left: 5px;
			}
		}

		.detail-pay {
			margin-top: 40px;
			font-weight: 600;
			font-size: 18px;
			line-height: 14px;
		}

		.detail-pay-content {
			font-size: 16px;
			line-height: 16px;
			display: flex;
			flex-direction: row;
			margin-top: 25px;

			> img {
				width: 27.86px;
				height: 15px;
			}

			> div {
				display: flex;
				flex-direction: column;
				padding-left: 12px;
				box-sizing: border-box;

				.detail-list-1 {
					font-size: 16px;
					line-height: 16px;
				}

				.detail-list-2 {
					font-size: 14px;
					line-height: 100%;
					color: #828282;
					margin-top: 10px;
				}

				.detail-list-3 {
					font-weight: 600;
					font-size: 16px;
					line-height: 16px;
					margin-top: 15px;
				}
			}
		}
	}

	.plan-message {
		font-size: 16px;
		line-height: 16px;
		text-align: center;
		display: flex;
		justify-content: center;
		flex-wrap: wrap;
		line-height: 30px;
	}

	.mandy {
		width: 90%;
		margin: 0 auto 50px;
	}
</style>


// WEBPACK FOOTER //
// src/views/PlanInformation.vue